import wireframeDonutChartMenuIcon from '../assets/icons/wireframeDonutChartMenuIcon.svg';
import WireframeImage from './WireframeImage';

class WireframeDonutChart extends WireframeImage {
  constructor(fabricObject) {
    fabricObject.style = 'donutChart';
    super(fabricObject);
  }

  static iconSvg() {
    return wireframeDonutChartMenuIcon;
  }

  static externalName(): string {
    return 'Donut chart';
  }
}

export default WireframeDonutChart;
